import Loader from './Loader';
import './loader.scss';

export default Loader;
